module.exports = __webpack_public_path__ + "static/img/hotel.7e6c09b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/hotel.png
// module id = 7uu3
// module chunks = 1